import OpportunityCandidates from "./OpportunityCandidates";

export default OpportunityCandidates;
